import React, { useState, useEffect } from "react";

export const svg = `<svg width="16" height="16" viewbox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 2.825 12.892.667h2.441v2.441L12.5 5.975c-.492-.333-.858-.5-1.1-.5-.933 0-3.858 2.2-3.858 3.25v2.267l-.734.741.284.309c-.009.058-.009.116-.009.183 0 .292.092.567.284.842L6.05 14.35 4.7 12.908l-2.542 2.425L.667 13.8l2.541-2.433-1.7-1.792L3.175 7.95l1.208 1.283 1.584-1.591h-.009l4.809-4.809-.017-.008ZM6.175 6.4c.025-.283.042-.625.025-1.042 0 0 .8-.241.658-1.475 0 0-1.275.009-1.433 1.017v1.45h-.742V4.892c-.158-1-1.433-1.017-1.433-1.017-.142 1.233.658 1.475.658 1.475-.066 2.083.492 2.333.492 2.333-1.442-.241-1.858-1.233-1.975-1.658a.14.14 0 0 1 .033-.125c.034-.033.075-.05.117-.042l.242.034V3.658c0-.616 1.241-1.508 1.875-1.841a.764.764 0 0 1 .733 0C6.058 2.158 7.3 3.042 7.3 3.658v1.634L6.175 6.4ZM15 12.208a.181.181 0 0 0-.167-.066l-.316.05V9.033c0-.875-1.734-2.125-2.625-2.608a1.066 1.066 0 0 0-1.025 0c-.892.483-2.625 1.733-2.625 2.608v3.159l-.334-.05a.189.189 0 0 0-.166.066.195.195 0 0 0-.042.175c.167.6.75 1.992 2.767 2.334 0 0-.784-.359-.692-3.3 0 0-1.125-.342-.925-2.084 0 0 1.775.017 2 1.434v2.058h1.042v-2.05c.216-1.417 2-1.433 2-1.433.2 1.733-.925 2.083-.925 2.083.083 2.95-.692 3.3-.692 3.3 2.025-.35 2.608-1.733 2.767-2.342a.195.195 0 0 0-.042-.175Z" fill="#595D66"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
